import { isExperimentActive, selectExperiments } from './experiments';
import { NEWBUILDING_15_PROMO_PINS_DESKTOP } from '../../constants/config';
import { IApplicationState } from '../../types/redux';

export function selectNewbuilding15PromoPinsDesktopEnabled(state: IApplicationState): boolean {
  const experiments = selectExperiments(state);

  return isExperimentActive(experiments, NEWBUILDING_15_PROMO_PINS_DESKTOP, 'B');
}
